"use strict";

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _slicedToArray2 = require("babel-runtime/helpers/slicedToArray");

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var debounce_1 = require("../utils/debounce");
var ReasonEditor_1 = require("../components/ReasonEditor");
var Container_1 = require("semantic-ui-react/dist/commonjs/elements/Container/Container");
var semantic_ui_react_5 = require("semantic-ui-react");
var Divider_1 = require("semantic-ui-react/dist/commonjs/elements/Divider/Divider");
var Dropdown_1 = require("semantic-ui-react/dist/commonjs/modules/Dropdown/Dropdown");
var Menu_1 = require("semantic-ui-react/dist/commonjs/collections/Menu/Menu");
var Button_1 = require("semantic-ui-react/dist/commonjs/elements/Button/Button");
var gatsby_utils_1 = require("../gatsby-utils");
var examples = [{
    name: "Tree sum",
    // tslint:disable-next-line:object-literal-sort-keys
    code: "type tree = Leaf | Node(int, tree, tree);\n\nlet rec sum =\n  fun\n  | Leaf => 0\n  | Node(value, left, right) => value + sum(left) + sum(right);\n\nlet myTree =\n  Node(\n    1,\n    Node(2, Node(4, Leaf, Leaf), Node(6, Leaf, Leaf)),\n    Node(3, Node(5, Leaf, Leaf), Node(7, Leaf, Leaf))\n  );\n\nsum(myTree) |> Js.log;"
}, {
    name: "FFI - Base64",
    // tslint:disable-next-line:object-literal-sort-keys
    code: "[@bs.val] external btoa : string => string = \"\";\n[@bs.val] external atob : string => string = \"\";\n\nlet text = \"Hello World!\";\nJs.log(text |> btoa);\nJs.log(text |> btoa |> atob);"
}, {
    name: "Recursion - Factorial",
    // tslint:disable-next-line:object-literal-sort-keys
    code: "/* Based on https://rosettacode.org/wiki/Factorial#Recursive_50 */\nlet rec factorial = (n) =>\n  n <= 0\n  ? 1\n  : n * factorial(n - 1);\n\nJs.log(factorial(6));"
}, {
    name: "Recursion - Greatest Common Divisor",
    // tslint:disable-next-line:object-literal-sort-keys
    code: "/* Based on https://rosettacode.org/wiki/Greatest_common_divisor#OCaml */\nlet rec gcd = (a, b) =>\n  switch (a mod b) {\n  | 0 => b\n  | r => gcd(b, r)\n  };\n\nJs.log(gcd(27, 9));"
}, {
    name: "Recursion - Towers of Hanoi",
    // tslint:disable-next-line:object-literal-sort-keys
    code: "/* Based on https://rosettacode.org/wiki/Towers_of_Hanoi#OCaml */\nlet rec hanoi = (n, a, b, c) =>\n  if (n > 0) {\n    hanoi(n - 1, a, c, b);\n    Js.log({j|Move disk from pole $a to pole $b|j});\n    hanoi(n - 1, c, b, a)\n  };\n\nhanoi(4, 1, 2, 3);"
}, {
    name: "Json",
    // tslint:disable-next-line:object-literal-sort-keys
    code: "let person = {\n  \"name\": {\"first\": \"Bob\", \"last\": \"Zhmith\"},\n  \"age\": 32\n};\n\nlet json =\n  person\n  |> Js.Json.stringifyAny\n  |> Js.Option.getExn\n  |> Js.Json.parseExn;\n\nlet name =\n  json\n  |> Js.Json.decodeObject\n  |> Js.Option.andThen([@bs] ((p) => Js.Dict.get(p, \"name\")))\n  |> Js.Option.andThen([@bs] ((json) => Js.Json.decodeObject(json)))\n  |> Js.Option.getExn;\n\nlet firstName =\n  Js.Dict.get(name, \"first\")\n  |> Js.Option.andThen([@bs] ((json) => Js.Json.decodeString(json)))\n  |> Js.Option.getExn;\n\nlet lastName =\n  Js.Dict.get(name, \"last\")\n  |> Js.Option.andThen([@bs] ((json) => Js.Json.decodeString(json)))\n  |> Js.Option.getExn;\n\nJs.log({j|Hello, $firstName $lastName|j});"
}, {
    name: "FizzBuzz",
    // tslint:disable-next-line:object-literal-sort-keys
    code: "/* Based on https://rosettacode.org/wiki/FizzBuzz#OCaml */\nlet fizzbuzz = (i) =>\n  switch (i mod 3, i mod 5) {\n  | (0, 0) => \"FizzBuzz\"\n  | (0, _) => \"Fizz\"\n  | (_, 0) => \"Buzz\"\n  | _ => string_of_int(i)\n  };\n\nfor (i in 1 to 100) {\n  Js.log(fizzbuzz(i))\n};"
}, {
    name: "Normal distribution of random numbers",
    // tslint:disable-next-line:object-literal-sort-keys
    code: "/* Based on https://rosettacode.org/wiki/Random_numbers#OCaml */\nlet pi = 4. *. atan(1.);\n\nlet random_gaussian = () =>\n  1. +. sqrt((-2.) *. log(Random.float(1.))) *. cos(2. *. pi *. Random.float(1.));\n\nArray.init(42, (_) => random_gaussian()) |> Array.iter(Js.log);"
}, {
    name: "Regex",
    // tslint:disable-next-line:object-literal-sort-keys
    code: "let input = {|\n  <html>\n    <head>\n      <title>A Simple HTML Document</title>\n    </head>\n    <body>\n      <p>This is a very simple HTML document</p>\n      <p>It only has two paragraphs</p>\n    </body>\n  </html>\n|};\n\ninput\n|> Js.String.match([%re \"/<p\\b[^>]*>(.*?)<\\/p>/gi\"])\n|> (\n  fun\n  | Some(result) => result |> Js.Array.forEach(Js.log)\n  | None => Js.log(\"no matches\")\n);"
}, {
    name: "Quicksort",
    // tslint:disable-next-line:object-literal-sort-keys
    code: "/* Based on https://rosettacode.org/wiki/Sorting_algorithms/Quicksort#OCaml */\nlet rec quicksort = (gt) =>\n  fun\n  | [] => []\n  | [x, ...xs] => {\n      let (ys, zs) = List.partition(gt(x), xs);\n      quicksort(gt, ys) @ [x, ...quicksort(gt, zs)]\n    };\n\n[4, 65, 2, (-31), 0, 99, 83, 782, 1] |> quicksort((>)) |> Array.of_list |> Js.log;"
}, {
    name: "String interpolation",
    // tslint:disable-next-line:object-literal-sort-keys
    code: "for (a in 1 to 10) {\n  for (b in 1 to 10) {\n    let product = a * b;\n    Js.log({j|$a times $b is $product|j})\n  }\n};"
}];
var errorTimeout = 500;
var waitUntilScriptsLoaded = function waitUntilScriptsLoaded(done) {
    if (window) {
        var tout = setInterval(function () {
            // test for bucklescript compiler existence and
            // refmt existence (one of the exposed method is printML)
            if (window.ocaml && window.printML) {
                clearInterval(tout);
                done();
            }
        }, 10);
    }
};
var formatErrorLocation = function formatErrorLocation(_ref) {
    var startLine = _ref.startLine,
        startLineStartChar = _ref.startLineStartChar,
        endLine = _ref.endLine,
        endLineEndChar = _ref.endLineEndChar;

    if (startLine === endLine) {
        if (startLineStartChar === endLineEndChar) {
            return "Line " + startLine + ":" + startLineStartChar;
        } else {
            return "Line " + startLine + ":" + startLineStartChar + "-" + endLineEndChar;
        }
    } else {
        return "Line " + startLine + ":" + startLineStartChar + "-Line " + endLine + ":" + endLineEndChar;
    }
};
var stripErrorNumberFromReasonSyntaxError = function stripErrorNumberFromReasonSyntaxError(error) {
    return error.replace(/\d+: /, "");
};
var capitalizeFirstChar = function capitalizeFirstChar(str) {
    if (str.length === 0) {
        return "";
    }
    return str[0].toUpperCase() + str.slice(1);
};

var Try = function (_React$Component) {
    (0, _inherits3.default)(Try, _React$Component);

    function Try() {
        (0, _classCallCheck3.default)(this, Try);

        var _this = (0, _possibleConstructorReturn3.default)(this, (Try.__proto__ || Object.getPrototypeOf(Try)).apply(this, arguments));

        _this.state = {
            autoEvaluate: true,
            js: "// loading",
            jsIsLatest: false,
            ocaml: "(* loading *)",
            output: [],
            reason: "/* loading */"
        };
        _this.outputOverloaded = false;
        _this.tryCompiling = debounce_1.default(function (reason, ocaml) {
            try {
                var _this$compile = _this.compile(ocaml),
                    _this$compile2 = (0, _slicedToArray3.default)(_this$compile, 2),
                    res = _this$compile2[0],
                    warning = _this$compile2[1];

                if (res.js_code) {
                    _this.setState(function (_) {
                        return {
                            compileWarning: warning,
                            js: res.js_code,
                            jsIsLatest: true
                        };
                    });
                    if (_this.state.autoEvaluate) {
                        _this.evalJs(res.js_code);
                    }
                    return;
                } else {
                    _this.errorTimerId = setTimeout(function () {
                        return _this.setState(function (_) {
                            return {
                                compileError: res,
                                compileWarning: null,
                                js: ""
                            };
                        });
                    }, errorTimeout);
                }
            } catch (err) {
                _this.errorTimerId = setTimeout(function () {
                    return _this.setState(function (_) {
                        return {
                            compileError: err,
                            compileWarning: null,
                            js: ""
                        };
                    });
                }, errorTimeout);
            }
            _this.setState(function () {
                return {
                    compileError: null,
                    compileWarning: null,
                    jsIsLatest: false,
                    output: []
                };
            });
        }, 100);
        _this.concatToOutputAndSetState = function (item) {
            return _this.setState(function (state) {
                return (0, _extends3.default)({}, state, {
                    output: state.output.concat(item)
                });
            });
        };
        _this.output = function (item) {
            if (_this.outputOverloaded) {
                return;
            }
            if (_this.state.output.length > 100) {
                _this.outputOverloaded = true;
                _this.concatToOutputAndSetState({ type: "error", contents: ["[Too much output!]"] });
                return;
            }
            _this.concatToOutputAndSetState(item);
        };
        _this.initEvalWorker = function () {
            _this.evalWorker = new Worker(gatsby_utils_1.withPrefix("/evalWorker.js"));
            _this.evalWorker.onmessage = function (_ref2) {
                var data = _ref2.data;

                if (data.type === "end") {
                    clearTimeout(data.contents);
                } else {
                    _this.output(data);
                }
            };
            _this.evalWorker.onerror = function (err) {
                _this.errorTimerId = setTimeout(function () {
                    return _this.setState(function (_) {
                        return {
                            jsError: err
                        };
                    });
                }, errorTimeout);
            };
        };
        _this.updateReason = function (newReasonCode) {
            if (newReasonCode === _this.state.reason) {
                return;
            }
            clearTimeout(_this.errorTimerId);
            _this.setState(function (prevState) {
                var newOcamlCode = prevState.ocaml;
                try {
                    var windowProxy = window;
                    newOcamlCode = windowProxy.printML(windowProxy.parseRE(newReasonCode));
                    _this.tryCompiling(newReasonCode, newOcamlCode);
                } catch (e) {
                    _this.errorTimerId = setTimeout(function () {
                        return _this.setState(function () {
                            return {
                                compileError: null,
                                js: "",
                                jsError: null,
                                ocaml: "",
                                ocamlSyntaxError: null,
                                output: [],
                                reasonSyntaxError: e
                            };
                        });
                    }, errorTimeout);
                }
                return {
                    compileError: null,
                    jsError: null,
                    ocaml: newOcamlCode,
                    ocamlSyntaxError: null,
                    reason: newReasonCode,
                    reasonSyntaxError: null
                };
            });
        };
        _this.updateOCaml = function (newOcamlCode) {
            if (newOcamlCode === _this.state.ocaml) {
                return;
            }
            clearTimeout(_this.errorTimerId);
            _this.setState(function (prevState) {
                var newReasonCode = prevState.reason;
                try {
                    newReasonCode = window.printRE(window.parseML(newOcamlCode));
                    _this.tryCompiling(newReasonCode, newOcamlCode);
                } catch (e) {
                    _this.errorTimerId = setTimeout(function () {
                        return _this.setState(function () {
                            return {
                                compileError: null,
                                js: "",
                                jsError: null,
                                ocamlSyntaxError: e,
                                output: [],
                                reason: "",
                                reasonSyntaxError: null
                            };
                        });
                    }, errorTimeout);
                }
                return {
                    compileError: null,
                    jsError: null,
                    ocaml: newOcamlCode,
                    ocamlSyntaxError: null,
                    reason: newReasonCode,
                    reasonSyntaxError: null
                };
            });
        };
        _this.compile = function (code) {
            var originalConsoleDotErrorBackup = console.error;
            var warning = "";
            console.error = function () {
                for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                    args[_key] = arguments[_key];
                }

                return args.forEach(function (argument) {
                    return warning += argument + "\n";
                });
            };
            var res = JSON.parse(window.ocaml.compile(code));
            console.error = originalConsoleDotErrorBackup;
            return [res, warning || null];
        };
        _this.toggleEvaluate = function () {
            if (!_this.state.autoEvaluate) {
                _this.evalLatest();
            }
            _this.setState(function () {
                return {
                    autoEvaluate: !_this.state.autoEvaluate
                };
            });
        };
        _this.evalLatest = function () {
            if (_this.state.jsIsLatest) {
                _this.evalJs(_this.state.js);
            }
        };
        return _this;
    }

    (0, _createClass3.default)(Try, [{
        key: "evalJs",
        value: function evalJs(code) {
            var _this2 = this;

            this.outputOverloaded = false;
            this.setState(function (state) {
                return (0, _extends3.default)({}, state, { output: [] });
            }, function () {
                var timerId = setTimeout(function () {
                    _this2.evalWorker.terminate();
                    _this2.initEvalWorker();
                    _this2.concatToOutputAndSetState({ type: "error", contents: ["[Evaluation timed out!]"] });
                }, 1000);
                _this2.evalWorker.postMessage({
                    code: wrapInExports(code),
                    timerId: timerId
                });
            });
        }
    }, {
        key: "componentDidMount",
        value: function componentDidMount() {
            var _this3 = this;

            waitUntilScriptsLoaded(function () {
                _this3.initEvalWorker();
                var _language$code = { language: "reason", code: examples[0].code },
                    language = _language$code.language,
                    code = _language$code.code;

                language === "reason" ? _this3.updateReason(code) : _this3.updateOCaml(code);
            });
        }
    }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
            if (this.evalWorker) {
                this.evalWorker.terminate();
            }
        }
    }, {
        key: "render",
        value: function render() {
            var _this4 = this;

            var _state = this.state,
                reason = _state.reason,
                ocaml = _state.ocaml,
                js = _state.js,
                reasonSyntaxError = _state.reasonSyntaxError,
                compileError = _state.compileError,
                compileWarning = _state.compileWarning,
                ocamlSyntaxError = _state.ocamlSyntaxError,
                jsError = _state.jsError;

            return React.createElement(Container_1.default, null, React.createElement(semantic_ui_react_5.Segment, { vertical: true, style: { border: "none" } }, React.createElement(Menu_1.default, null, React.createElement(Dropdown_1.default, { item: true, text: "Examples" }, React.createElement(Dropdown_1.default.Menu, null, examples.map(function (example) {
                var cb = function cb(e, _ref3) {
                    var value = _ref3.value;

                    _this4.updateReason(value);
                };
                return React.createElement(Dropdown_1.default.Item, { key: example.name, onClick: cb, value: example.code }, example.name);
            }))), !this.state.autoEvaluate && React.createElement(Menu_1.default.Item, null, React.createElement(Button_1.default, { primary: true, onClick: this.evalLatest }, "Evaluate Now")), React.createElement(Menu_1.default.Item, { name: "autoEvaluate", active: this.state.autoEvaluate, content: "Auto Evaluate", onClick: this.toggleEvaluate, icon: "refresh" }))), React.createElement(semantic_ui_react_5.Segment, { vertical: true, style: { border: "none" } }, React.createElement("div", null, React.createElement("div", null, React.createElement(ReasonEditor_1.default, { reason: reason, ocaml: ocaml, js: js, onUpdateCode: this.updateReason, result: this.state.output.map(function (item, i) {
                    return formatOutput(item);
                }).join("\n") }), reasonSyntaxError && React.createElement("div", null, React.createElement("div", null, formatErrorLocation(reasonSyntaxError.location), " ", capitalizeFirstChar(stripErrorNumberFromReasonSyntaxError(reasonSyntaxError.message))))), React.createElement("div", null, ocamlSyntaxError && React.createElement("div", null, React.createElement("div", null, ocamlSyntaxError.message)), compileError && React.createElement("div", null, React.createElement("div", null, compileError.js_error_msg ? compileError.js_error_msg : compileError.message)), compileWarning && React.createElement("div", null, React.createElement("div", null, compileWarning)))), React.createElement("div", null, React.createElement("div", null, jsError && React.createElement("div", null, React.createElement("div", null, jsError.message)))), React.createElement(Divider_1.default, null)));
        }
    }]);
    return Try;
}(React.Component);

exports.default = Try;
var wrapInExports = function wrapInExports(code) {
    return "(function(exports) {" + code + "})({})";
};
var formatOutput = function formatOutput(item) {
    return item && item.contents ? "" + item.contents.join(" ") : "";
};


// WEBPACK FOOTER //
// ./~/babel-loader/lib?{"presets":["babel-preset-env"],"plugins":["/home/travis/build/codekiln/gradus-reason/~/gatsby/dist/utils/babel-plugin-extract-graphql.js"]}!./~/ts-loader!./src/pages/try.tsx